import { Link } from "react-router-dom";
import { ArrowRight, Heart, Flame, Leaf } from "lucide-react";

const AMBIANCE = "https://images.unsplash.com/photo-1712630514718-3830cc6c0d0a?crop=entropy&cs=srgb&fm=jpg&q=85";
const FEAST = "https://images.pexels.com/photos/13994299/pexels-photo-13994299.jpeg?auto=compress&cs=tinysrgb&w=940";

const VALUES = [
  { icon: Flame, title: "Cooked with Fire", desc: "Smoky, bold, and authentic — the way West African food is meant to taste." },
  { icon: Leaf, title: "Fresh Ingredients", desc: "Hand-picked produce, proteins, and spices sourced for real flavor." },
  { icon: Heart, title: "Made with Heart", desc: "Family recipes passed down and served with genuine Nigerian hospitality." },
];

export default function About() {
  return (
    <div>
      <section className="relative overflow-hidden bg-stone-950">
        <img src={AMBIANCE} alt="" className="absolute inset-0 h-full w-full object-cover opacity-35" />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-950 via-stone-950/80 to-transparent" />
        <div className="relative mx-auto max-w-6xl px-6 py-24">
          <span className="inline-flex items-center gap-2 rounded-full bg-orange-700/20 px-4 py-1.5 text-sm font-semibold text-amber-400"><Flame className="h-4 w-4" /> Our Story</span>
          <h1 className="mt-4 max-w-2xl font-display text-4xl font-extrabold leading-tight text-white sm:text-6xl">A taste of West Africa, made in Orlando.</h1>
          <p className="mt-5 max-w-xl text-lg text-stone-300">Flavors Nigerian Restaurant was born from a love of home cooking and a mission to share the vibrant, soulful food of Nigeria with our Orlando community.</p>
        </div>
      </section>

      <section className="mx-auto grid max-w-6xl gap-10 px-6 py-16 lg:grid-cols-2 lg:items-center">
        <div className="space-y-4 text-stone-700">
          <h2 className="font-display text-3xl font-bold text-stone-900">From our kitchen to your table</h2>
          <p>What started as cooking for friends and family quickly became a calling. Every plate of jollof, every bowl of egusi, and every swallow carries the warmth of Nigerian tradition.</p>
          <p>We keep it simple: authentic recipes, bold spices, and generous portions. No shortcuts — just real food, cooked fresh, ready for you to pick up hot and enjoy.</p>
          <Link to="/menu" className="inline-flex items-center gap-2 rounded-full bg-orange-700 px-6 py-3 font-bold text-white transition-colors duration-200 hover:bg-orange-800">
            Explore the Menu <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
        <img src={FEAST} alt="Nigerian feast" className="h-80 w-full rounded-3xl object-cover shadow-lg" />
      </section>

      <section className="bg-stone-900 py-16">
        <div className="mx-auto max-w-6xl px-6">
          <h2 className="font-display text-3xl font-bold text-amber-400">What we stand for</h2>
          <div className="mt-8 grid gap-6 sm:grid-cols-3">
            {VALUES.map((v) => (
              <div key={v.title} className="rounded-2xl border border-stone-800 bg-stone-800/50 p-6">
                <v.icon className="h-7 w-7 text-orange-500" />
                <h3 className="mt-4 font-display text-xl font-bold text-stone-100">{v.title}</h3>
                <p className="mt-2 text-sm text-stone-400">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
